import { Skeleton } from "antd"; // Import Skeleton from Ant Design
import { fetchProject } from "api/counsilors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  AddIconWithCircle,
  ArticleEmptyIcon,
  InitiativesIcon,
} from "themes/Icon";
import { isPermit } from "utils/permissionCheck";

import style from "../../councillor_profile.module.scss";

export default function Initiatives({
  open,
  setOpen,
  counsilors,
  seletedItem,
}) {
  const { selectedCounsilor } = useSelector((state) => state.counsilor);
  const navigate = useNavigate();

  const [recentInitiatives, setRecentInitiatives] = useState([]); // Store the fetched data
  const [loading, setLoading] = useState(false); // Local loading state

  // Fetch the project data when component mounts
  useEffect(() => {
    setLoading(true); // Set loading to false once data is fetched or if there is an error

    const fetchInitiatives = async () => {
      try {
        const response = await fetchProject({
          status: 4,
          page: 1,
          perPage: 3,
          wardNo: String(selectedCounsilor?.ward_code),
        });

        if (response?.projects) {
          setRecentInitiatives(response.projects);
        } else {
          setRecentInitiatives([]);
        }
      } catch (error) {
      } finally {
        setLoading(false); // Set loading to false once data is fetched or if there is an error
      }
    };

    if (selectedCounsilor?.ward_code !== null) {
      fetchInitiatives();
    } else {
      setLoading(false); // Set loading to false once data is fetched or if there is an error
    }
  }, [selectedCounsilor?.ward_code]);

  return (
    <div className={style["resume-section"]}>
      <div className="flex align-center justify-between">
        <div className="flex align-center gap-2">
          <span>
            <InitiativesIcon />
          </span>
          <h4 className={style["section-title"]}>
            Recent Initiatives & Projects
          </h4>
        </div>
        {/* {selectedCounsilor?.projects > 0 && ( */}
        {isPermit(8, "create") && (
          <button
            onClick={() => navigate("/all-articles")}
            className={style["add-btn"]}
          >
            <AddIconWithCircle />
            Add
          </button>
        )}
      </div>

      <div>
        {loading ? (
          <div className={style["initiatives-wrapper"]}>
            {Array(3)
              .fill(0)
              .map((_, i) => (
                <div key={i} className={style["card-container"]}>
                  <Skeleton.Image active style={{ width: 200, height: 120 }} />
                  <Skeleton active paragraph={{ rows: 2 }} />
                </div>
              ))}
          </div>
        ) : recentInitiatives.length > 0 ? (
          <div className={style["initiatives-wrapper"]}>
            {recentInitiatives.map((item, i) => (
              <div key={i} className={style["card-container"]}>
                <span className={style["card-image"]}>
                  <img src={item?.images[0]?.project_image} alt={item.title} />
                </span>
                <div className={style["card-content"]}>
                  <h6 className={style["card-title"]}>{item.title}</h6>
                  <p className={style["card-desc"]}>{item.description}</p>
                  <p className={style["card-reading-time"]}>{item.read_time}</p>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {recentInitiatives.length === 0 && !loading && (
          <div
            className={`${style["empty-state"]} ${style["initiatives-empty-state"]}`}
          >
            <ArticleEmptyIcon />
            <h6 className={style["empty-state-text"]}>
              There are no articles to show yet.
            </h6>
          </div>
        )}
      </div>
    </div>
  );
}
